enum CardsOrderStatusProductionStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export default CardsOrderStatusProductionStatus;
